<template>
	<div class="card">
		<div class="card-header bg-dark">
			<h3 class="mb-0 text-white">รายการรับโบนัสแต่ละประเภท</h3>
		</div>

		<el-table row-key="id" header-row-class-name="thead-light" :data="data">
			<el-table-column label="โบนัส" min-width="275px">
				<div slot-scope="{ row }">
					{{ row.name }}
				</div>
			</el-table-column>
			<el-table-column label="จำนวนที่รับ" min-width="100px">
				<div slot-scope="{ row }">
					{{ row.count | format(0) }}
				</div>
			</el-table-column>
			<el-table-column label="จำนวนเงิน" min-width="100px">
				<div slot-scope="{ row }">
					{{ row.amount | format }}
				</div>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui'

export default {
	props: ['data'],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
}
</script>
